import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import PVSHomePage from './components/PVSHomePage';
import LPGInventorySystem from './components/LPGInventorySystem';
import PDFViewer from './components/PDFViewer';
import VesselMindPage from './vesselmind/VesselMindPage';

// Protected wrapper component for VesselMind (admin and readonly users)
const VesselMindWrapper = () => {
  const navigate = useNavigate();
  
  const userData = localStorage.getItem('user');
  let isAdmin = false;
  let userRole = 'standard';
  
  try {
    if (userData) {
      const user = JSON.parse(userData);
      isAdmin = user.isAdmin === true;
      userRole = user.role || 'standard';
    }
  } catch (error) {
    console.error('Error checking admin status:', error);
  }
  
  if (!isAdmin && userRole !== 'readonly') {
    console.warn('⚠️ Non-admin/non-readonly user attempted to access VesselMind');
    return <Navigate to="/home" replace />;
  }
  
  return <VesselMindPage onReturnHome={() => navigate('/home')} />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<PVSHomePage />} />
        <Route path="/vesselmind" element={<VesselMindWrapper />} />
        <Route path="/pvs-form" element={<div>PVS Form</div>} />
        <Route path="/calculator" element={<div>Calculator</div>} />
        <Route path="/wse" element={<div>Written Scheme of Examination</div>} />
        <Route path="/LPGTankInventory" element={<LPGInventorySystem />} />
        <Route path="/viewer/:docId" element={<PDFViewer />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;